import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { asyncActions } from '../actions/general';
import { finishSession, getRoute, loading } from '../actions/sessions';

function useSession() {
  const [session] = useState(
    useSelector((state) => state.sessions.get('session'))
  );
  const dispatch = useDispatch();

  const sessionActions = {
    finish: () => {
      dispatch(loading(true));
      return dispatch(asyncActions(finishSession(session.action))).then(() =>
        dispatch(loading(false))
      );
    },
    nextStep: () => dispatch(getRoute()),
  };

  return [session, sessionActions];
}

export default useSession;
